import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import rehypeRaw from 'rehype-raw';
import { cn } from '../lib/utils';

interface MarkdownProps {
  content: string;
  className?: string;
  style?: React.CSSProperties;
}

export const Markdown: React.FC<MarkdownProps> = ({ content, className, style }) => {
  if (!content) return null;

  return (
    <div className={cn("break-words max-w-full overflow-hidden", className)} style={style}>
      <ReactMarkdown remarkPlugins={[remarkGfm, remarkBreaks]} rehypePlugins={[rehypeRaw]}>
        {content}
      </ReactMarkdown>
    </div>
  );
};
